'use client';

let isAlgoliaDown = false;
let healthCheckInterval: NodeJS.Timeout | null = null;

// PRODUCTION: Always use real Algolia monitoring API
const HEALTH_CHECK_URL = '/api/algolia-health-check';

// DEVELOPMENT CODE - COMMENTED OUT FOR PRODUCTION
// const HEALTH_CHECK_URL =
//   process.env.NEXT_PUBLIC_ALGOLIA_USE_TEST_API === 'true'
//     ? '/api/test-algolia-health-check'
//     : '/api/algolia-health-check';

const ALGOLIA_CLUSTER = process.env.NEXT_PUBLIC_ALGOLIA_CLUSTER || 'c14-usc';

const performHealthCheck = async (): Promise<boolean> => {
  try {
    // PRODUCTION: Always use real Algolia monitoring API
    const response = await fetch(`${HEALTH_CHECK_URL}?cluster=${ALGOLIA_CLUSTER}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      console.log(`Algolia health check failed: ${response.status}`);
      return false;
    }

    const data = await response.json();
    const isHealthy = data.healthy === true;
    console.log(`Algolia cluster ${ALGOLIA_CLUSTER} status: ${isHealthy ? 'HEALTHY' : 'UNHEALTHY'}`);
    return isHealthy;

    // DEVELOPMENT CODE - COMMENTED OUT FOR PRODUCTION
    // if (process.env.NEXT_PUBLIC_ALGOLIA_USE_TEST_API === 'true') {
    //   const response = await fetch(HEALTH_CHECK_URL, {
    //     method: 'GET',
    //     headers: { 'Content-Type': 'application/json' },
    //   });
    //   const isHealthy = response.ok;
    //   console.log(`Algolia health check: ${isHealthy ? 'HEALTHY' : 'UNHEALTHY'}`);
    //   return isHealthy;
    // } else {
    //   const response = await fetch(`${HEALTH_CHECK_URL}?cluster=${ALGOLIA_CLUSTER}`, {
    //     method: 'GET',
    //     headers: { 'Content-Type': 'application/json' },
    //   });

    //   if (!response.ok) {
    //     console.log(`Algolia health check failed: ${response.status}`);
    //     return false;
    //   }

    //   const data = await response.json();
    //   const isHealthy = data.healthy === true;
    //   console.log(`Algolia cluster ${ALGOLIA_CLUSTER} status: ${isHealthy ? 'HEALTHY' : 'UNHEALTHY'}`);
    //   return isHealthy;
    // }
  } catch (error) {
    console.error('Algolia health check failed:', error);
    return false;
  }
};

const startHealthCheckInterval = () => {
  if (healthCheckInterval) {
    console.log('Health check interval already running, skipping duplicate start');
    return;
  }

  console.log('Starting Algolia health check interval (every 10 seconds for faster recovery)');
  healthCheckInterval = setInterval(async () => {
    const isHealthy = await performHealthCheck();
    if (isHealthy && isAlgoliaDown) {
      isAlgoliaDown = false;
      console.log('Algolia is back online! Health checks stopped.');
      if (healthCheckInterval) {
        clearInterval(healthCheckInterval);
        healthCheckInterval = null;
      }
    }
  }, 60000);
};

export const markAlgoliaAsDown = () => {
  if (!isAlgoliaDown) {
    isAlgoliaDown = true;
    console.log('Algolia is down! Starting health checks...');
    startHealthCheckInterval();
  }
};

export const getAlgoliaFailoverStatus = () => isAlgoliaDown;

export const cleanupAlgoliaFailover = () => {
  if (healthCheckInterval) {
    clearInterval(healthCheckInterval);
    healthCheckInterval = null;
  }
};
